export const ADD_MIXPANEL_EVENT = "ADD_MIXPANEL_EVENT"